import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/mobile/investAndFinancing/consignmentInsurance',
    },
    {
      path: '/mobile/investAndFinancing/combinationTreasure',
      component: () =>
        import('@/views/financial_mobile/CombinationTreasure/template.vue'),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '组合宝'],
        category: 'investAndFinancing',
        title: '组合宝',
      },
    },
    {
      path: '/mobile/combinationTreasureDetails',
      component: () =>
        import(
          '@/views/financial_mobile/CombinationTreasure/combinationTreasureDetails.vue'
        ),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '组合宝'],
        title: '组合宝',
      },
    },
    {
      path: '/mobile/combinationTreasureCpmx',
      component: () =>
        import(
          '@/views/financial_mobile/CombinationTreasure/combinationTreasureCpmx.vue'
        ),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '组合宝'],
        title: '组合宝产品明细',
      },
    },
    // 首页>客户服务
    {
      path: '/mobile/customerService/exchangeRate',
      // component: () =>
      //   import('@/views/financial_mobile/ExchangeRate/template.vue'),
      component: () =>
        import('@/views/financial_mobile/ExchangeRateNew/template.vue'),
      meta: {
        location: ['首页', '客户服务', '外汇牌价'],
        category: 'customerService',
        title: '外汇牌价',
      },
    },
    {
      path: '/mobile/customerService/exchangeRate_New',
      component: () =>
        import('@/views/financial_mobile/ExchangeRateNew/template.vue'),
      meta: {
        location: ['首页', '客户服务', '新版外汇牌价'],
        category: 'customerService',
        title: '新版外汇牌价',
      },
    },
    // 零售金融>财富管理>个人存款
    {
      path: '/mobile/personalDeposit/wholeDepositAndWithdraw',
      component: () =>
        import('@/views/financial_mobile/WholeDepositAndWithdraw/template.vue'),
      meta: {
        location: [
          '零售金融',
          '财富管理',
          '个人存款',
          '传统储蓄理财',
          '整存整取',
        ],
        category: 'personalDeposit',
        title: '整存整取',
      },
    },
    {
      path: '/mobile/personalDeposit/callDeposit',
      component: () =>
        import('@/views/financial_mobile/CallDeposit/template.vue'),
      meta: {
        location: [
          '零售金融',
          '财富管理',
          '个人存款',
          '传统储蓄理财',
          '通知存款',
        ],
        category: 'personalDeposit',
        title: '通知存款',
      },
    },
    {
      path: '/mobile/personalDeposit/secureDeposit',
      component: () =>
        import('@/views/financial_mobile/SecureDeposit/template.vue'),
      meta: {
        location: [
          '零售金融',
          '财富管理',
          '个人存款',
          '华兴特色存款',
          '安兴存',
        ],
        category: 'personalDeposit',
        title: '安兴存',
      },
    },
    {
      path: '/mobile/personalDeposit/certificateDeposit',
      component: () =>
        import('@/views/financial_mobile/CertificateDeposit/template.vue'),
      meta: {
        location: ['零售金融', '财富管理', '个人存款', '个人大额存单'],
        category: 'personalDeposit',
        title: '个人大额存单',
      },
    },
    {
      path: '/mobile/certificateDepositDetail',
      component: () =>
        import(
          '@/views/financial_mobile/CertificateDeposit/certificateDepositDetail.vue'
        ),
      meta: {
        location: ['零售金融', '财富管理', '个人存款', '个人大额存单'],
        title: '个人大额存单',
      },
    },
    {
      path: '/mobile/personalDeposit/flexibleProfit',
      component: () =>
        import('@/views/financial_mobile/FlexibleProfit/template.vue'),
      meta: {
        location: [
          '零售金融',
          '财富管理',
          '个人存款',
          '华兴特色存款',
          '灵活盈',
        ],
        category: 'personalDeposit',
        title: '灵活盈',
      },
    },
    {
      path: '/mobile/flexibleProfitDetail',
      component: () =>
        import(
          '@/views/financial_mobile/FlexibleProfit/flexibleProfitDetail.vue'
        ),
      meta: {
        location: [
          '零售金融',
          '财富管理',
          '个人存款',
          '华兴特色存款',
          '灵活盈',
        ],
        title: '灵活盈',
      },
    },
    // 利率>人民币储蓄存款利率
    {
      path: '/mobile/interestRate/rmbcxckll',
      component: () =>
        import('@/views/financial_mobile/InterestRate/rmbCxckLl.vue'),
      meta: {
        location: ['首页', '金融信息', '利率', '人民币储蓄存款利率'],
        category: 'interestRate',
        title: '人民币储蓄存款利率',
      },
    },
    // 利率>人民币单位存款利率查询
    {
      path: '/mobile/interestRate/rmbdwckllcx',
      component: () =>
        import('@/views/financial_mobile/InterestRate/rmbDwckLlcx.vue'),
      meta: {
        location: ['首页', '金融信息', '利率', '人民币单位存款利率查询'],
        category: 'interestRate',
        title: '人民币单位存款利率查询',
      },
    },
    // 利率>人民币贷款利率
    {
      path: '/mobile/interestRate/rmbdkll',
      component: () =>
        import('@/views/financial_mobile/InterestRate/rmbDkLl.vue'),
      meta: {
        location: ['首页', '金融信息', '利率', '人民币贷款利率'],
        category: 'interestRate',
        title: '人民币贷款利率',
      },
    },
    // 利率>小额外币存款利率查询
    {
      path: '/mobile/interestRate/xewbckllcx',
      component: () =>
        import('@/views/financial_mobile/InterestRate/xeWbckLlcx.vue'),
      meta: {
        location: ['首页', '金融信息', '利率', '小额外币存款利率查询'],
        category: 'interestRate',
        title: '小额外币存款利率查询',
      },
    },
    // 利率>人民币贷款市场利率（LPR）
    {
      path: '/mobile/interestRate/rmbdkscll',
      component: () =>
        import('@/views/financial_mobile/InterestRate/rmbDkscLl.vue'),
      meta: {
        location: ['首页', '金融信息', '利率', '人民币贷款市场利率（LPR）'],
        category: 'interestRate',
        title: '人民币贷款市场利率（LPR）',
      },
    },
    // 个人大额存单（产品公告）
    {
      path: '/mobile/manual/depositManual',
      component: () =>
        import('@/views/financial_mobile/Manual/depositManual.vue'),
      meta: {
        location: ['零售金融', '产品公告', '存款产品', '个人大额存单'],
        category: 'productManual',
        title: '个人大额存单',
      },
    },
    // 移动端
    // 零售金融>财富管理>投资理财
    {
      path: '/mobile/treasureTrove/incomeCalculator',
      component: () =>
        import('@/views/financial_mobile/IncomeCalculator/template.vue'),
      meta: {
        title: '收益计算器'
      }
    },
    // 零售金融>财富管理>投资理财
    {
      path: '/mobile/treasureTrove/loanCalculator',
      component: () =>
        import('@/views/financial_mobile/LoanCalculator/template.vue'),
      meta: {
        title: '贷款计算器',
      },
    },
    {
      path: '/mobile/treasureTrove/loanCalculatorDetail',
      component: () =>
        import('@/views/financial_mobile/LoanCalculator/calculationDetail.vue'),
      meta: {
        title: '贷款计算器',
      },
    },
    // 零售金融>财富管理>私人银行>私行专属产品
    {
      path: '/mobile/investAndFinancing/privateBankProduct',
      component: () =>
        import('@/views/financial_mobile/PrivateBank/template.vue'),
      meta: {
        location: ['零售金融', '财富管理', '私人银行', '私行专属产品'],
        category: 'investAndFinancing',
        title: '理财',
      },
    },
    {
      path: '/mobile/investAndFinancing/financialProduct',
      component: () =>
        import('@/views/financial_mobile/FinancialProducts/template.vue'),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '理财'],
        category: 'investAndFinancing',
        title: '理财',
      },
    },
    {
      path: '/mobile/financialProductDetail',
      component: () =>
        import(
          '@/views/financial_mobile/FinancialProducts/financialDetails.vue'
        ),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '理财'],
        category: 'investAndFinancing',
        title: '理财',
      },
    },
    {
      path: '/mobile/financeList',
      component: () =>
        import('@/views/financial_mobile/FinancialProducts/financeList.vue'),
    },
    {
      path: '/mobile/investAndFinancing/commissionFund',
      component: () =>
        import('@/views/financial_mobile/CommissionFund/template.vue'),
      meta: {
        title: '代销基金'
      }
    },
    {
      path: '/mobile/commissionFundDetails',
      component: () =>
        import(
          '@/views/financial_mobile/CommissionFund/commissionFundDetails.vue'
        ),
      meta: {
        title: '代销基金'
      }
    },
    {
      path: '/mobile/fundDocument',
      component: () =>
        import('@/views/financial_mobile/CommissionFund/fundDocument.vue'),
    },
    {
      path: '/mobile/tradeRules',
      component: () =>
        import('@/views/financial_mobile/CommissionFund/tradeRules.vue'),
    },
    {
      path: '/mobile/fundManager',
      component: () =>
        import('@/views/financial_mobile/CommissionFund/fundManager.vue'),
    },

    {
      path: '/mobile/investAndFinancing/consignmentInsurance',
      component: () =>
        import('@/views/financial_mobile/ConsignmentInsurance/template.vue'),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '代销保险'],
        category: 'investAndFinancing',
        title: '代销保险',
      },
    },
    {
      path: '/mobile/consignmentInsuranceDetails',
      component: () =>
        import(
          '@/views/financial_mobile/ConsignmentInsurance/consignmentInsuranceDetails.vue'
        ),
      meta: {
        location: ['零售金融', '财富管理', '投资理财', '代销保险'],
        title: '代销保险',
      },
    },
    {
      path: '/mobile/investAndFinancing/commissionGold',
      component: () =>
        import('@/views/financial_mobile/CommissionGold/template.vue'),
    },
    {
      path: '/mobile/investAndFinancing/consignmentManagementTrust',
      component: () =>
        import(
          '@/views/financial_mobile/ConsignmentManagementTrust/template.vue'
        ),
      meta: {
        title: '代销资管信托'
      }
    },
    {
      path: '/mobile/consignmentManagementTrustDetails',
      component: () =>
        import(
          '@/views/financial_mobile/ConsignmentManagementTrust/ManagementTrustDetails.vue'
        ),
      meta: {
        title: '代销资管信托'
      }
    },
  ],
  base: `${process.env.VUE_APP_PACKAGE_NAME}`,
  scrollBehavior: function () {
    return {
      x: 0,
      y: 0,
    }
  },
})

router.beforeEach((to, from, next) => {
  // 检查路由是否有 meta.title
  if (to.meta && to.meta.title) {
    document.title = `广东华兴银行_${to.meta.title}`
  } else {
    document.title = '广东华兴银行' // 默认标题
  }
  next()
})

export default router
